import {modalConfirm} from 'app/utils/modals/popups';
import I18n from 'app/i18n';
import {locationQuery} from 'app/utils/navigate/location';
import {Location} from 'react-router-dom';
import {toastSuccess, toastError} from 'app/components/toasts/liteToast';
import Post from 'app/utils/Post';

export const showTelegramLinkConfirmation = (telegram_linked: boolean, location: Location): void => {
    const params = locationQuery(location);
    const telegramState = params.telegram_state;

    if (!telegramState) {
        return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('telegram_state');
    window.history.replaceState({}, '', url.toString());

    if (telegram_linked) {
        toastError(I18n.t('telegram.errors.user_already_linked'));
        return;
    }

    modalConfirm(
        I18n.t('telegram.labels.confirm_link_account'),
        () => makeRequestToLinkTelegram(telegramState)
    );
};

const makeRequestToLinkTelegram = (state: string): void => {
    new Post({params: {state}, url: '/telegram/link_account'})
        .execute()
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                toastSuccess(data.message || I18n.t('telegram.success.account_linked'));
            } else {
                toastError(data.error || I18n.t('telegram.errors.failed_to_link_account'));
            }
        })
        .catch(() => {
            toastError(I18n.t('telegram.errors.failed_to_link_account'));
        });
};
